import React from 'react';
import { getDialogStyles } from './styles';

export const InstallGuide = ({ onBack, onClose, colors }) => {
  const isIOS = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
  const platform = isIOS ? "iOS" : /Android/.test(window.navigator.userAgent) ? "Android" : "Desktop";
  const styles = getDialogStyles(colors);

  const renderInstallSteps = () => {
    if (isIOS) {
      return (
        <>
          <div style={styles.step}>
            <span style={styles.stepNumber}>1</span>
            <span>Tap the Share button 📲</span>
          </div>
          <div style={styles.step}>
            <span style={styles.stepNumber}>2</span>
            <span>Scroll and tap "Add to Home Screen" ✚</span>
          </div>
          <div style={styles.step}>
            <span style={styles.stepNumber}>3</span>
            <span>Tap "Add" to install</span>
          </div>
        </>
      );
    } else if (platform === "Android") {
      return (
        <>
          <div style={styles.step}>
            <span style={styles.stepNumber}>1</span>
            <span>Tap the menu button ⋮</span>
          </div>
          <div style={styles.step}>
            <span style={styles.stepNumber}>2</span>
            <span>Select "Install app" or "Add to Home screen"</span>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div style={styles.step}>
            <span style={styles.stepNumber}>1</span>
            <span>Click "Install" in the address bar 📥</span>
          </div>
          <div style={styles.step}>
            <span style={styles.stepNumber}>2</span>
            <span>Follow the installation prompts</span>
          </div>
        </>
      );
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.dialog} onClick={e => e.stopPropagation()}>
        <button onClick={onBack} style={styles.backButton}>
          <span style={styles.menuIcon}>←</span>
          <span style={styles.menuText}>Back</span>
        </button>
        <div style={styles.subMenu}>
          {renderInstallSteps()}
        </div>
        <button onClick={onClose} style={styles.closeButton}>Close</button>
      </div>
    </div>
  );
};
